<template lang="pug">
    .game-content(v-if='playersNumber')
        games-wrapper(
            :type='type',
            :exercise-id='exerciseId',
            :homework-id='homeworkId',
            :players-number='playersNumber',
            :play-again='playAgain'
        )
</template>

<script>
    import PlayBox from './PlayBox.vue';
    import { mapState } from 'vuex';
    import GamesWrapper from '../GamesWrapper.vue';

    export default {
        props: {
            exerciseId: [Number, String],
            homeworkId: [Number, String],
            type: String,
        },
        data() {
            return {
                playAgain: false,
                playAgainReadyScreens: 0,
                checkAnswersReadyScreens: 0,
            };
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                paramsArray: state => state.trainer.paramsArray,
            }),
            playersNumber() {
                return this.paramsArray ? this.paramsArray.length : 1;
            },
        },
        components: {
            PlayBox,
            GamesWrapper,
        },
        beforeRouteLeave(to, from, next) {
            if (this.$store.state.trainer.game) {
                if (!(to.meta.type && to.meta.type === 'trainer')) {
                    this.$store.dispatch('setHomework', null);
                    this.$store.dispatch('setGame', null);
                }
            }
            next();
        },
    };
</script>
<style lang="scss" scoped>
    @import '@/assets/sass/games/main.scss';
</style>
